"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = download;

var _fetcher = _interopRequireDefault(require("./fetcher"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// download ability
// @author Pluto <huarse@gmail.com>
// @create 2020/02/24 09:49
function getFilename(headers) {
  const disposition = headers.get('content-disposition') || '';
  return (disposition.match(/filename=(.+)$/i) || [])[1] || null;
}

function download(api, options) {
  return (0, _fetcher.default)(api, options, async (response, options) => {
    const blob = response.blob();
    const filename = options.filename || getFilename(response.headers);
    const link = document.createElement('a');
    link.style.display = 'none';
    link.href = URL.createObjectURL(blob);

    if (filename) {
      link.download = decodeURIComponent(filename);
    }

    link.click();
    URL.revokeObjectURL(link.href);
  });
}